"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useStyles = {
    "invosys-ui-LoginAvatar-styledLink": {
        textDecoration: "underline",
        cursor: "pointer"
    }
};
exports.default = useStyles;
